import styled from 'styled-components';

export const IntroMessage = styled.div`
  color: ${(props) => props.theme.navy.string()};
  margin: 0.2rem auto 0.8rem;
  max-width: 400px;
  text-align: center;
`;
